var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alpha-footer',{attrs:{"company":_vm.$t('Layout.Footer.company'),"facebook":"https://www.facebook.com/van.romaine","instagram":"https://www.instagram.com/van.romaine","categories":_vm.categories}},[_c('span',[_vm._v("\n    © 2021\n    "+_vm._s(_vm.$t('Layout.Footer.company'))+"\n    —\n    "+_vm._s(_vm.$t('Layout.Footer.rights'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }